import { ProductsGridWebComponent } from './component/ProductsGridWebComponent';
import { WEB_COMPONENT_PRODUCTS_GRID } from '../../../../../../../webcomponents.constants';

window.customElements.define(WEB_COMPONENT_PRODUCTS_GRID, ProductsGridWebComponent);

export { ProductsGridWebComponent };
